import { useEffect, useState } from "react"
import CubeScene from "../components/3DTest/MeshPointsCanvas"
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import { Machine } from "../utils/models/Machine";
import { ISelectOptions } from "aw-combobox";
import { getAllMachines } from "../utils/services/machine.service";
import { AWGrid, TableData } from "aw-grid";
import { Spinner } from "react-bootstrap";
import D3DataGrid from "../components/3DTest/3DData/3DDataGrid.component";
import { AWSelect } from "aw-select";
import { useTheme } from "../utils/contexts/ThemeContext";
import PropertiesVisualization from "../components/3DTest/PropertiesVisualization/3DPropertiesVisualization.component"
import { ModelProperties } from "../components/3DTest/mesh-points-hook";

const Page3D = () => {

    const tableBody: TableData[] = [
        { item: [1, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [2, '12VAD8YF845T2', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [3, '12VAD8VVX1496', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [4, '12VAD8QTA8415', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [5, '12VAD8OPL7743', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [6, '12VAD8QQC1578', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [7, '12VAD8PLY4456', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [8, '12VAD8MBC1423', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [9, '12VAD8PLA1597', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true }]

    const user = useSelector(selectUser)
    const { t } = useTranslation();
    const context: IOutletContext = useOutletContext()
    const [modelImg, setModelImg] = useState('')
    const [machines, setMachines] = useState<Machine[]>([])
    const [machinesObj, setMachinesObj] = useState<ISelectOptions[]>([])
    const [selectedMachine, setSelectedMachine] = useState<ISelectOptions>()
    const [loadingData, setLoadingData] = useState(false)
    const [loadingDataGrid, setLoadingDataGrid] = useState(false)
    const [currentData, setCurrentData] = useState<TableData>(tableBody[0])


    const tableHeaders = [t('NSerie'), t('Model'), t('MaterialCode'), t('Start'), t('Time')]


    useEffect(() => {
        context.setState(t('3D'))
    })

    useEffect(() => {
        getAllMachines(user.token)
            .then((machines: Machine[]) => setMachines(machines))
            .catch((e) => console.log('Error get machines', e))
    }, [])

    useEffect(() => {
        if (machines.length > 0) {
            const mObj: ISelectOptions[] = []
            machines.forEach((m) => {
                mObj.push({ value: m.idmachine, label: m.name })
            })
            mObj.sort((a, b) => Number(a.value) - Number(b.value))
            setMachinesObj(mObj)
            setSelectedMachine(mObj[0])
        } else
            setMachinesObj([])
    }, [machines])

    useEffect(() => {
        onLoading(true)
    }, [selectedMachine])

    const onLoading = (all: boolean) => {
        if (all) {
            setLoadingDataGrid(true)
            setTimeout(() => {
                setLoadingDataGrid(false)
            }, 1000)
        }

        setLoadingData(true)
        setTimeout(() => {
            setLoadingData(false)
        }, 1000)
    }

    const onEditClick = (id: number | string) => {
        const item = tableBody.find((i) => i.item[0] === id)
        if (item) {
            setCurrentData(item)
            onLoading(true)
        }
    }
    
    const theme = useTheme();
    const dark = theme.theme==='dark';
    const [selectedProperty, setSelectedProperty] = useState<keyof ModelProperties>('stress')

    return (
        <>
            <div className='row border-0 mx-1' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-sm-8 col-md px-2 mt-1'>
                    <div className='rounded-1 p-2 d-flex flex-column' style={{ backgroundColor: 'var(--background-secondary)', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
                        <section style={{ width: '15rem' }}>
                            <AWSelect dark={dark} className="w-100" disabled={false} closeMenuOnSelect={true} value={selectedMachine} onChange={(e: any) => setSelectedMachine(e)} options={machinesObj} />
                        </section>
                    </div>
                </div>
            </div >
            <div className='row border-0 ms-2 me-2 d-flex' style={{ maxWidth: '100%'}}>
                <div className='col-12 col-md-6 mt-1 p-1'>
                    <div className='p-2 rounded-1 d-flex flex-column text-center' style={{ backgroundColor: 'var(--background-secondary)', color: 'var(--text-primary)', height: '100%', width: '100%', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
                        <span className="h2 mb-2">{t('Model')}</span>
                        {!loadingData && <CubeScene  selectedProperty={selectedProperty}  setModelImg={setModelImg} token={user.token}/>}
                        {loadingData && <div className="text-center"><Spinner animation="border" variant="success" /></div>}
                    </div>
                </div>
                <div className='col-12 col-md-6 mt-1 p-1 d-flex flex-column h-100'  >
                    <PropertiesVisualization  selectedProperty={selectedProperty}
  setSelectedProperty={setSelectedProperty}/>
                    <D3DataGrid currentData={currentData} loadingData={loadingData} modelImg={modelImg} />
                </div>
            </div >
            <div className='row border-0 mb-3 ms-2 me-2'>
                <div className='col px-1 mt-1'>
                    <AWGrid loading={loadingDataGrid} noDataText={t('NoData')} onDeleteClick={() => null} onEditClick={onEditClick} tableData={tableBody}
                        tableHeaders={tableHeaders} bgColor="var(--background-secondary)" textColor="var(--text-primary)" title={t('ManufacturedItems')} manage={false} gridStyle="gridsStyle" spinnerColor="var(--accent-color)" />
                </div>
            </div>
        </>
    )
}
export default Page3D